import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { REST_API } from "../services/constants";
import authHeader from "../services/auth-header";
import axios from "axios";

// Scope direkt hier definieren, kein Import nötig
const graphRequest = {
  scopes: ["User.Read"],
};

export default function ProfileImage({
  className = "",
  style = {},
  width = 40,
  height = 40,
  alt = "Profilbild",
}) {
  const { instance, accounts } = useMsal();
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let isMounted = true;
    let blobUrl = null;

    const loadPhoto = async () => {
      const activeAccount = instance.getActiveAccount() || accounts[0];
      if (!activeAccount) return;

      try {
        // 1. Token für Microsoft Graph holen
        const response = await instance.acquireTokenSilent({
          ...graphRequest,
          account: activeAccount,
        });

        // 2. Bild von Microsoft Graph abrufen
        const graphRes = await fetch(
          "https://graph.microsoft.com/v1.0/me/photo/$value",
          {
            headers: {
              Authorization: `Bearer ${response.accessToken}`,
            },
          },
        );

        if (graphRes.ok) {
          const blob = await graphRes.blob();
          blobUrl = URL.createObjectURL(blob);
          if (isMounted) setImageSrc(blobUrl);
          return;
        }
      } catch (err) {
        console.warn(
          "Microsoft-Profilbild nicht verfügbar, Fallback auf Backend:",
          err,
        );
      }

      // 3. Fallback: Bild vom Backend
      try {
        const backendRes = await axios.get(
          `${REST_API}/api/secure/users/session/get_profile_picture/`,
          {
            headers: await authHeader(),
            responseType: "blob",
          },
        );
        if (backendRes.status === 200 && isMounted) {
          blobUrl = URL.createObjectURL(backendRes.data);
          setImageSrc(blobUrl);
        }
      } catch (backendErr) {
        console.warn("Kein Backend-Profilbild gefunden.");
      }
    };

    loadPhoto();

    return () => {
      isMounted = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [instance, accounts]);

  if (!imageSrc) {
    return (
      <div
        className={`profile-placeholder ${className}`}
        style={{
          width: `${width}px`,
          height: `${height}px`,
          borderRadius: "50%",
          backgroundColor: "#ccc",
          display: "inline-block",
          ...style,
        }}
      />
    );
  }

  return (
    <img
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        borderRadius: "50%",
        objectFit: "cover",
        ...style,
      }}
    />
  );
}
